import React from 'react';

import { IntakeManagementPageInitialProps } from '~/data';
import {
  QueryParameterContextProvider,
  ApplicationProvider,
  SearchResultContextProvider,
  SelectedIntakesContextProvider,
  SessionContextProvider,
  StaticPropsContextProvider,
} from '~/context';
import { Application } from '@ab/ams-school-api/types/private/v1';

interface ProgramEditProviderProps {
  application: Application;
  children: React.ReactNode;
  initialProps: IntakeManagementPageInitialProps; // to-do: update to correct type
}
export function ProgramEditProvider(props: Readonly<ProgramEditProviderProps>) {
  return (
    <SessionContextProvider>
      <StaticPropsContextProvider initialProps={props.initialProps}>
        <ApplicationProvider application={props.application}>
          <QueryParameterContextProvider>
            <SelectedIntakesContextProvider>
              <SearchResultContextProvider>{props.children}</SearchResultContextProvider>
            </SelectedIntakesContextProvider>
          </QueryParameterContextProvider>
        </ApplicationProvider>
      </StaticPropsContextProvider>
    </SessionContextProvider>
  );
}
